import ServiceDataModel from '../../../../data-models/Service.DataModel';
import ServiceTypeEntity from '../../../../entities/ServiceType.Entity';
import { translationTypes } from '../../../../support/constants/TranslationTypes.Constants';

/**
 * Returns the translation sub-service (OSI, VI, etc.) matching the user's selection order.
 * At most one TL sub-service is expected per TT referral; TP is ignored.
 */
export function resolveSelectedTranslationServiceType(
    services: ServiceDataModel[],
    selectedServiceTypeIds: number[],
): ServiceTypeEntity | undefined {
    const serviceTypeById = new Map<number, ServiceTypeEntity>();
    for (const service of services ?? []) {
        for (const serviceType of service.serviceTypes ?? []) {
            serviceTypeById.set(serviceType.serviceTypeId, serviceType);
        }
    }

    for (const serviceTypeId of selectedServiceTypeIds ?? []) {
        const serviceType = serviceTypeById.get(serviceTypeId);
        if (serviceType && translationTypes.includes(serviceType.serviceTypeAbbreviation)) {
            return serviceType;
        }
    }

    return undefined;
}
